export const InstructorRelationshipType = Object.freeze({
    All: 0,
    Exclusive: 1,
    Employee: 2
});